import { Card, CardContent, Dialog, DialogContent, DialogTitle, Fab, Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import AltLocationAutocomplete from 'components/AddressLocationForm/LocationForm/AltLocationAutocomplete';
import { MapBox } from 'components/AddressLocationForm/MapBox';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useUpdateEffect } from "usehooks-ts";
import { useTrackEvent } from 'util/trackEvent';
import { AddressComponentForm, AddressComponentFormDialog } from './AddressComponentForm';
import { useGeolocation } from 'util/useGeolocation';
import { Button } from "@material-ui/core";
import { MyLocation, Add, PinDrop } from "@material-ui/icons";
import { Layer, Marker, Source } from 'react-map-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapPin } from "@fortawesome/free-solid-svg-icons";
import voca from 'voca'
const useStyles = makeStyles(theme => ({
}));
const AddLocationWithMap = ({
  locationType,
  onConfirmNewLocation = (loc) => { },
  onCTARef
}) => {
  const theme = useTheme()
  const trackEvent = useTrackEvent()
  const classes = useStyles()
  const [newLocation, setNewLocation] = useState(null);

  const [openLocationInfoForm, setOpenLocationInfoForm] = useState(false);

  const [marker, setMarker] = useState({
    latitude: 14.562909599624389,
    longitude: 121.03317570610837
  });

  const [manualMarker, setManualMarker] = useState({
    latitude: 14.562909599624389,
    longitude: 121.03317570610837
  });
  const [selectedAddress, setSelectedAddress] = useState(null);

  const mapRef = useRef(null);

  useUpdateEffect(
    () => {
      mapRef?.current?.setCenter([marker.longitude, marker.latitude])
    }, [marker]
  );

  const updateMapFromGeolocation = useCallback(
    (browserLatLng) => {
      if (!browserLatLng?.lat || !browserLatLng?.lng) {
        return
      }
      trackEvent('Create Booking Location Form - Use My Location ', { dialog: ['LocationConfirmDialog', 'LocationForm'] })
      mapRef?.current?.setCenter([browserLatLng?.lng, browserLatLng?.lat]);
      setMarker({
        latitude: browserLatLng?.lat,
        longitude: browserLatLng?.lng
      })
      setManualMarker({
        latitude: browserLatLng?.lat,
        longitude: browserLatLng?.lng
      })
    },
    [],
  );

  const {
    dialog,
    error: geolocationError,
    isGeolocationEnabled,
    latLng: browserLatLng,
    fetchNewLocation
  } = useGeolocation({ watchLocation: false });


  const CTAButtonProps = useMemo(
    () => {
      return {
        disabled: !selectedAddress,
        onClick: () => {
          setOpenLocationInfoForm(true)
        },
        children: selectedAddress ? 'Add Location Info' : 'Select a location first'
        
      }
      
    }, [setOpenLocationInfoForm, selectedAddress]
  );

  useEffect(
    () => {
      onCTARef && onCTARef(CTAButtonProps)
    }, [CTAButtonProps]
  );
  return (
    <>
      <AltLocationAutocomplete
        locationType={locationType}
        browserLocation={browserLatLng}
        sessionToken={null}
        centerLocation={marker}
        onSelectAddress={address => {
          setMarker({
            latitude: address.latitude,
            longitude: address.longitude
          })
          setSelectedAddress(address)

        }}
        overrideAddress={{
          latitude: manualMarker.latitude,
          longitude: manualMarker.longitude

        }}
      />
      <div
        style={{
          position: 'relative',
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
        }}
      >
        <MapBox
          // key={refreshKey}
          onRef={(ref) => {
            mapRef.current = ref
          }}
          style={{ height: '50vh' }}
          canvasDrag
          center={{ latitude: marker?.latitude, longitude: marker?.longitude }}
          markerLocation={{ latitude: marker?.latitude, longitude: marker?.longitude }}
          onMarkerDragEnd={(lnglat) => {
            setSelectedAddress(null)
            setMarker({
              latitude: lnglat.lat,
              longitude: lnglat.lng
            })
            setManualMarker({
              latitude: lnglat.lat,
              longitude: lnglat.lng
            })
            trackEvent('Create Booking Location Form - Pin Moved ', { dialog: ['LocationConfirmDialog', 'LocationForm'], lnglat })
          }}
        >
          {
            browserLatLng?.lat && browserLatLng?.lng && (
              <Marker
                longitude={browserLatLng.lng}
                latitude={browserLatLng.lat}
                offset={[0, -20]}
              >
                <FontAwesomeIcon icon={faMapPin} size="3x" />
              </Marker>
            )
          }
          {/* <Source
            id="polyline"
            type="geojson"
            data={{
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'LineString',
                coordinates: [
                  [marker.longitude, marker.latitude],
                  [browserLatLng?.lng, browserLatLng?.lat]
                ]
              }
            }}
          >
            <Layer
              id="line"
              type="line"
              source="polyline"
              layout={{
                'line-join': 'round',
                'line-cap': 'round'
              }}
              paint={{
                'line-color': '#ff0000',
                'line-width': 5
              }}
            />
          </Source> */}
        </MapBox>
        <Fab
          color="secondary"
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
          onClick={async () => {
            const loc = await fetchNewLocation()
            updateMapFromGeolocation(loc)
          }} ><MyLocation /></Fab>
      </div>


      <AddressComponentFormDialog
        open={openLocationInfoForm}
        onCTARef={onCTARef}
        onCancel={() => setOpenLocationInfoForm(false)}
        locationType={locationType}
        location={selectedAddress}
        onSubmit={(formData) => {
          onConfirmNewLocation({
            ...formData,
            ...selectedAddress,
            type_name: locationType
          })
        }}
      />

    </>
  )
}

export const LOCATION_TYPE_NAMES = [
  'home',
  'office',
  'condo',
  'hotel',
]

const AddLocationWDialogWrapper = (props) => {
  const [locationType, setLocationType] = useState(null);
  const trackEvent = useTrackEvent()
  return (
    <>
      <Dialog
        open={!locationType}
        onClose={null}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          style={{
            textAlign: 'center'

          }}>
          <Typography variant="h4">
            What type of location is this?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {LOCATION_TYPE_NAMES.map((type, index) => (
              <Grid item xs={6} key={index}>
                <Card
                  onClick={() => {
                    setLocationType(type)
                    trackEvent('Create Booking Location Form - Select Location Type Icon', { type })
                  }}
                >
                  <CardContent>
                    <img src={`/assets/images/locationtype/${type}.png`} alt={type} style={{ width: '100%' }} />
                  </CardContent>
                  <CardContent>
                    <Typography variant="h6" align="center">{voca.upperCase(type)}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
            }
          </Grid>
        </DialogContent>
      </Dialog>
      <AddLocationWithMap locationType={locationType} {...props} />
    </>
  )
}


export { AddLocationWDialogWrapper as AddLocationWithMap }